import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ICONS, Preview } from '@app/styles';
import { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
import { Button, ComponentSync, LL_H_C, TS_Checkbox, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { dbObjectToId, exists } from '@nu-art/ts-common';
import { ModuleFE_DiseaseProfile } from '../../../../../_entity.js';
import { Toaster } from '@nu-art/toasting';
import { ConfigKeyFE_DiseasesTagId, DropDown_Variable, ModuleFE_Variable } from '@app/hcs-frontend';
import { valueID_YesSuspectedNo } from '@app/hcs-shared';
import { DropDown_ColorGroup } from '../../../../../_entity/color-group/ui-components.js';
import './Dialog_NewDiseaseProfile.scss';
export class Dialog_NewDiseaseProfile extends ComponentSync {
    toaster = new Toaster('preview__new-disease-profile');
    static show = (onSave) => {
        const model = {
            key: 'add-new-disease-profile',
            className: 'preview-window',
            rect: { ...windowRect.thirdScreen_Middle(), height: undefined },
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Dialog_NewDiseaseProfile, { onClose: cb, onSave: onSave })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    // ######################## Logic ########################
    canSave = () => {
        return exists(this.state.variableId) && exists(this.state.colorGroupId);
    };
    save = async () => {
        if (!this.canSave())
            return;
        const profile = {
            variableId: this.state.variableId,
            colorGroup: this.state.colorGroupId,
            label: 'New Disease Profile',
            initials: '',
            referenceIds: [],
            chiefComplaintIds: [],
            icd: [],
            tagIds: [],
            _variableIds: [],
            _valueIds: [],
            _tagIds: [],
        };
        try {
            const diseaseProfile = await ModuleFE_DiseaseProfile.v1.upsert(profile).executeSync();
            this.props.onSave(diseaseProfile);
            this.props.onClose();
            this.toaster.toastSuccess({
                title: 'Disease Profile Creation',
                body: 'New disease profile successfully created',
            });
        }
        catch (err) {
            this.logError(err);
            this.toaster.toastError({
                title: 'Disease Profile Creation',
                body: `Disease profile creation failed: ${err.message}`,
            });
        }
    };
    getViableVarIds = () => {
        const existingIds = new Set(ModuleFE_DiseaseProfile.cache.all().map(dp => dp.variableId));
        const diseaseTagId = ConfigKeyFE_DiseasesTagId.get();
        const hideAssigned = this.state.hideAssigned !== false; // default: hide already-assigned
        return ModuleFE_Variable.cache.filter(variable => {
            // A disease variable must carry the Yes/Suspected/No value set — CareMap
            // emits disease findings as SUSPECTED, so any other value type cannot
            // represent the outcome. This invariant is always enforced.
            if (variable.valueId !== valueID_YesSuspectedNo)
                return false;
            if (!variable._tagIds.includes(diseaseTagId))
                return false;
            // A disease variable has a 1:1 profile, so assigned ones are hidden by
            // default — but the toggle lets an editor inspect/reuse them.
            if (hideAssigned && existingIds.has(variable._id))
                return false;
            return true;
        }).map(dbObjectToId);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(Preview.Root, { className: 'dialog__add-new-disease-profile', children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: "Add Disease Profile" }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.onClose }) })] });
    };
    render_Main = () => {
        return _jsx(Preview.Main, { children: _jsxs(Preview.MainColumn, { children: [this.render_Variable(), this.render_ColorGroup(), _jsx(Button, { variant: 'primary', onClick: this.save, disabled: !this.canSave(), children: "Save" })] }) });
    };
    render_Variable = () => {
        const viableIds = new Set(this.getViableVarIds());
        const hideAssigned = this.state.hideAssigned !== false;
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Variable', children: [_jsx(DropDown_Variable, { queryFilter: variable => viableIds.has(variable._id), onSelected: variable => this.setState({ variableId: variable?._id }), selected: this.state.variableId, limitItems: 50 }), _jsxs(LL_H_C, { className: 'dialog__add-new-disease-profile__hide-assigned', children: [_jsx(TS_Checkbox, { className: 'quai', icon: _jsx(ICONS.v.component, {}), checked: hideAssigned, onCheck: () => this.setState({ hideAssigned: !hideAssigned }) }), _jsx("span", { children: "Hide variables already assigned to a profile" })] })] });
    };
    render_ColorGroup = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Color Group', children: _jsx(DropDown_ColorGroup.selectable, { onSelected: group => this.setState({ colorGroupId: group?._id }), selected: this.state.colorGroupId, limitItems: 50 }) });
    };
}
//# sourceMappingURL=Dialog_NewDiseaseProfile.js.map